import type { WeekRequestLine } from '../../lib/requests/week-requests.ts';
import { copy } from '../copy/en-CA.ts';

const c = copy.schedule.requests;

/**
 * One week's cell in the admin's Requests column: "Dr. Chen › Vacation",
 * one line per physician, "(awaiting approval)" after a request that was
 * not used, and the line of the physician on call that week in bold (and
 * said so to a screen reader). Empty when nobody asked for anything.
 */
export function WeekRequests({ lines, names, onCallId }: { lines: readonly WeekRequestLine[]; names: ReadonlyMap<string, string>; onCallId: string | null }) {
  if (lines.length === 0) return null;
  return (
    <div className="week-requests">
      {/* On a phone the table's headers are not shown, so the card says what these lines are. */}
      <span className="week-requests-label">{c.header}</span>
      <ul>
        {lines.map((l) => {
          const onCall = l.physicianId === onCallId;
          return (
            <li key={`${l.physicianId}|${l.kind}`} className={onCall ? 'on-call' : undefined}>
              {names.get(l.physicianId)}
              <span className="visually-hidden">:</span> <span aria-hidden="true">›</span> {c.kinds[l.kind]}
              {l.pending ? ` ${c.pending}` : null}
              {onCall ? <span className="visually-hidden">, {c.onCall}</span> : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
